import React, { FC, useEffect, useState } from 'react';

// REDUX
import { useAppSelector, useAppDispatch } from '@Managers/Redux/Hooks';
import { getMenuPages, setMenuPages } from '@Managers/Redux/AppState/AppState';

//MODULES
import MenuPagesPopup from './MenuPages.popup';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EButtonEvents } from '@Managers/Events/ButtonEvents';

const MenuPages: FC<{}> = ({}) => {
    const currentSettings = useAppSelector(getMenuPages);
    const [isPopupOpen, setIsPopupOpen] = useState<boolean | undefined>(false);

    const dispatch = useAppDispatch();

    const openPopup = (): void => {
        setIsPopupOpen(true);
    };

    EventsCenter.on(EButtonEvents.SPIN_BUTTON_PRESSED, () => {
        if (isPopupOpen) closePopup();
    });

    const closePopup = (): void => {
        setIsPopupOpen(false);
        dispatch(setMenuPages(false));
    };

    useEffect(() => {
        if (currentSettings) {
            openPopup();
        }

        if (isPopupOpen && !currentSettings) closePopup();
    }, [isPopupOpen, currentSettings]);

    return <>{isPopupOpen && <MenuPagesPopup onClose={closePopup} isPopupOpen={isPopupOpen} />}</>;
};

export default MenuPages;
